// Generated by LiveScript 1.6.0
var id, log, whichKey, findInside, map, filter, fold, flip, delay, tween, scroll, rnd, max, int, round, wrap, limit, tail, span, initial, takeWhile, dropWhile, head, join, trim, split, lines, unwords, lowercase, slug, out$ = typeof exports != 'undefined' && exports || this, slice$ = [].slice;
out$.id = id = function(it){
  return it;
};
out$.log = log = (typeof console != 'undefined' && console !== null ? console.log : void 8) == null
  ? function(){
    return arguments[0];
  }
  : function(){
    console.log.apply(console, arguments);
    return arguments[0];
  };
out$.whichKey = whichKey = function(code, λ){
  return function(arg$){
    var keyCode;
    keyCode = arg$.keyCode;
    if (keyCode === code) {
      return λ.apply(this, arguments);
    }
  };
};
out$.findInside = findInside = curry$(function($el, sel){
  return $(sel, $el);
});
out$.map = map = curry$(function(λ, xs){
  var i$, len$, x, results$ = [];
  for (i$ = 0, len$ = xs.length; i$ < len$; ++i$) {
    x = xs[i$];
    results$.push(λ(x));
  }
  return results$;
});
out$.filter = filter = curry$(function(λ, xs){
  var i$, len$, x, results$ = [];
  for (i$ = 0, len$ = xs.length; i$ < len$; ++i$) {
    x = xs[i$];
    if (λ(x)) {
      results$.push(x);
    }
  }
  return results$;
});
out$.fold = fold = curry$(function(λ, m, xs){});
out$.flip = flip = curry$(function(λ, a, b){
  return λ(b, a);
});
out$.delay = delay = flip(setTimeout);
out$.tween = tween = function(start, end, time, λstep, λdone){
  var z;
  λdone == null && (λdone = id);
  z = {
    val: start
  };
  return $(z).animate({
    val: end
  }, {
    duration: time,
    step: λstep,
    complete: λdone
  });
};
out$.scroll = scroll = function(dest, time, λ){
  time == null && (time = 600);
  λ == null && (λ = id);
  return tween($(document).scrollTop(), dest, time, function(it){
    return $(document).scrollTop(it);
  }, λ);
};
out$.rnd = rnd = Math.random;
out$.max = max = Math.max;
out$.int = int = partialize$.apply(this, [parseInt, [void 8, 10], [0]]);
out$.round = round = Math.round;
out$.wrap = wrap = curry$(function(min, max, n){
  if (n < min) {
    return max;
  } else if (n > max) {
    return min;
  } else {
    return n;
  }
});
out$.limit = limit = curry$(function(min, max, n){
  if (n < min) {
    return min;
  } else if (n > max) {
    return max;
  } else {
    return n;
  }
});
out$.tail = tail = function(xs){
  if (xs.length) {
    return xs.slice(1);
  } else {
    return [];
  }
};
out$.span = span = curry$(function(p, xs){
  return [takeWhile(p, xs), dropWhile(p, xs)];
});
out$.initial = initial = function(xs){
  if (xs.length) {
    return xs.slice(0, -1);
  } else {
    return [];
  }
};
out$.takeWhile = takeWhile = curry$(function(p, xs){
  var len, i;
  len = xs.length;
  if (!len) {
    return xs;
  }
  i = 0;
  while (i < len && p(xs[i])) {
    i += 1;
  }
  return xs.slice(0, i);
});
out$.dropWhile = dropWhile = curry$(function(p, xs){
  var len, i;
  len = xs.length;
  if (!len) {
    return xs;
  }
  i = 0;
  while (i < len && p(xs[i])) {
    i += 1;
  }
  return xs.slice(i);
});
if (String.prototype.trim == null) {
  String.prototype.trim = function(){
    return this.replace(/^\s*(\S*(?:\s+\S+)*)\s*$/, "$1");
  };
}
out$.head = head = function(xs){
  return xs[0];
};
out$.join = join = curry$(function(char, str){
  return str.join(char);
});
out$.trim = trim = function(str, chr){
  chr == null && (chr = ' ');
  return str.trim(chr);
};
out$.split = split = curry$(function(char, str){
  return str.split(char);
});
out$.lines = lines = split("\n");
out$.unwords = unwords = join(' ');
out$.lowercase = lowercase = function(it){
  return String(it).toLowerCase();
};
out$.slug = slug = function(){
  var breakIt, noSpaces, breakAtCaps;
  breakIt = curry$(function(p, xs){
    return span(compose$(p, not$), xs);
  });
  noSpaces = function(it){
    return it.replace(/\s+/g, '-');
  };
  breakAtCaps = function(word){
    return breakIt(function(it){
      return it === it.toUpperCase();
    }, word);
  };
  return function(msg){
    return join('-')(
    filter(id)(
    map(noSpaces)(
    map(trim)(
    breakAtCaps(
    lowercase(
    msg))))));
  };
}();
/*

# Timers

export defer = -> delay 0, it
export every = flip set-interval


# Math functions

export floor = Math.floor
export random-int  = (a, b) -> a + floor end! * b
export random-from = (xs) -> xs[ floor rnd! * xs.length ]


# List Processors

export append = (xs, ys) --> if typeof! ys is \String then xs + ys else xs ++ ys
export take = (n, xs) --> if n <= 0 then xs.slice 0, 0 else xs.slice 0, n
export drop = (n, xs) --> if n <= 0 then xs else xs.slice n

export contains = (list, needle) ->
  for x in list
    if x is needle then return true
  return false


# Generators

export uid = do -> i = 0; -> i++


# DOM/jQuery Functions

export check-ie8 = -> $('html.ie8').exists!

export put = (code, host) ->
  if host? then $(host).append(code)
  code


# String Functions

export has-char = (str, char) -> -1 < str.index-of char
export letters = split ''
export unletters = join''
export words = split ' '
export unlines = join "\n"
export uppercase = (msg) -> String(msg).toUpperCase!

export pad = (length, input, char='0') -->
  if String input .length < length
    leading = strpad (length - String(input).length), char
    leading + input
  else
    input


# Export

more =
  abbrev      : (str) -> x = words str |> map head |> unletters
  uppercase   : uppercase
  linkify     : (text)  -> text.replace /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig, "<a href='$1'>$1</a>"
  serialise   : (opt)   -> s = ( for k,v of opt then k + "=" + v ); "?" + s.join '&'
  deserialise : (str)   -> map = {}; str.replace(/[?&]+([^=&]+)=([^&]*)/gi, (m,key,value) -> map[key] = value); map


# Proxy

export ajax      = require \./ajax
export analytics = require \./ga


*/
function curry$(f, bound){
  var context,
  _curry = function(args) {
    return f.length > 1 ? function(){
      var params = args ? args.concat() : [];
      context = bound ? context || this : this;
      return params.push.apply(params, arguments) <
          f.length && arguments.length ?
        _curry.call(context, params) : f.apply(context, params);
    } : f;
  };
  return _curry();
}
function partialize$(f, args, where){
  var context = this;
  return function(){
    var params = slice$.call(arguments), i,
        len = params.length, wlen = where.length,
        ta = args ? args.concat() : [], tw = where ? where.concat() : [];
    for(i = 0; i < len; ++i) { ta[tw[0]] = params[i]; tw.shift(); }
    return len < wlen && len ?
      partialize$.apply(context, [f, ta, tw]) : f.apply(context, ta);
  };
}
function compose$() {
  var functions = arguments;
  return function() {
    var i, result;
    result = functions[0].apply(this, arguments);
    for (i = 1; i < functions.length; ++i) {
      result = functions[i](result);
    }
    return result;
  };
}
function not$(x){ return !x; }
//# sourceMappingURL=data:application/json;base64,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

